import React from "react";

const ExperienceItem = ({ title, name, duration, details }) => {
  return (
    <ol className="flex  flex-col md:flex-row  border-l border-stone-200">
      <li className="mb-10 ml-4">
        {/* <div className="absolute w-3 h-3 bg-stone-200 rounded-full mt-2 -left-1.5 border-white" /> */}
        <p className="flex flex-wrap gap-4 flex-row items-center justify-start">
          <span className="font-bold text-2xl px-2 inline-block">{title}</span>
          <span className="text-xl px-2 inline-block text-gray-400">
            {name}
          </span>
          <span className="font-normal text-lg px-2 inline-block text-stone-400">
            {duration}
          </span>
        </p>
        <p>
          <span className="my-2 px-2 text-base font-normal text-stone-400">
            {details}
          </span>
        </p>
      </li>
    </ol>
  );
};

export default ExperienceItem;
